(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/react/components/footer/get-app.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/react/components/footer/get-app.js');

'use strict';

const {
  Button,
  ReactIcon: Icon
} = svs.ui;
const {
  useAtomValue
} = jotai;
const {
  activeMethodAtom
} = svs.iam_login.atoms;
const GetApp = () => {
  const activeMethod = useAtomValue(activeMethodAtom);
  return React.createElement("div", {
    className: "footer-btns"
  }, React.createElement(Button, {
    "aria-label": "Skaffa ".concat(activeMethod.methodName, " (\xF6ppnas i nytt f\xF6nster)"),
    className: "get-app-button",
    iconPosition: "right",
    onClick: () => {
      window.open(activeMethod.appUrl, '_blank');
    },
    role: "link",
    transparent: true
  }, React.createElement(Icon, {
    className: "unstyled-icon",
    icon: "link-external",
    size: "300"
  }), "Skaffa ".concat(activeMethod.methodName)));
};
svs.iam_login.components.footer.GetApp = GetApp;

 })(window);